import { useQuery } from 'react-query';
import api from 'api';

export const EMPLOYEE_DATA_GENERAL_QUERY_KEY = ['employee-data-settings', 'general'];

export const useEmployeeDataGeneralSettings = () =>
  useQuery(EMPLOYEE_DATA_GENERAL_QUERY_KEY, async () => {
    const response = await api.employeeDataSettings.queries.getEmployeeDataGeneralSettings();
    return response.payrollEmployeeDataGeneralSettings.data;
  });
